/**
 *
 * Permissions
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import Select, { createFilter } from "react-select";

const Permissions = (props) => {
  const {
    sharedUsersTeams,
    users,
    inactiveUsers,
    teams,
    onSetUserInput,
    jobCreatedBy,
    fromAutomation,
    fromResultsShare,
    fromAdvanced,
    componentZIndex = 1,
    usersTeamsValid,
  } = props;
  const noPadding = { zIndex: componentZIndex }; // ***** WAYNE: this is the z-index I had to add
  const options = [];
  const handlePermissionsChoice = (optionsArray, { action, removedValue }) => {
    if (
      (action === "remove-value" || action === "pop-value") &&
      removedValue.value.split("_")[0] === String(jobCreatedBy)
    ) {
      alert("The job creator cannot be removed from the job."); // eslint-disable-line no-alert
      return;
    }
    let filteredOptionsArray = optionsArray;
    if (action === "clear") {
      filteredOptionsArray = sharedUsersTeams.filter(
        (sharedUT) => sharedUT.value.split("_")[0] === String(jobCreatedBy)
      );
    }
    if (fromAutomation) {
      onSetUserInput("sharedUsers", filteredOptionsArray);
    } else {
      onSetUserInput(filteredOptionsArray);
    }
  };
  options.push({ value: "usersTitle", label: "USERS", disabled: true });
  users
    .sort((user1, user2) =>
      user1.get("fullName").toLowerCase() > user2.get("fullName").toLowerCase()
        ? 1
        : -1
    )
    .forEach((user) => {
      if (!user.get("suspendedByUserAccountId")) {
        options.push({
          value: `${user.get("userAccountId")}_user`,
          label: user.get("fullName"),
        });
      }
    });
  options.push({ value: "teamsTitle", label: "TEAMS", disabled: true });
  teams
    .sort((team1, team2) =>
      team1.get("teamName").toLowerCase() > team2.get("teamName").toLowerCase()
        ? 1
        : -1
    )
    .forEach((team) => {
      options.push({
        value: `${team.get("teamId")}_team`,
        label: team.get("teamName"),
      });
    });

  let sharedUsersTeamsJS = sharedUsersTeams.toJS
    ? sharedUsersTeams.toJS()
    : sharedUsersTeams;
  sharedUsersTeamsJS = sharedUsersTeamsJS.map((userTeam) => {
    const userTeamInfo = userTeam.value.split("_");
    let label = null;
    const userToAdd =
      users.get(userTeamInfo[0]) ||
      (inactiveUsers && inactiveUsers.get(userTeamInfo[0]));
    if (userTeamInfo[1] === "user" && userToAdd) {
      label = userToAdd.get("fullName");
    } else if (
      userTeamInfo[1] === "team" &&
      teams &&
      teams.get(userTeamInfo[0])
    ) {
      label = teams.get(userTeamInfo[0]).get("teamName");
    }
    if (label !== null) {
      return {
        value: userTeam.value,
        label,
      };
    }
    return null;
  });
  const customFilter = createFilter({ ignoreCase: true });
  return (
    <div>
      {!fromAutomation && !fromAdvanced && (
        <Row>
          <Col lg={12} md={12} sm={12}>
            <strong>
              {fromResultsShare
                ? "Which users or teams would you like to share these results with?"
                : "Which users or teams would you like to share this job with?"}
            </strong>
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={7} md={7} sm={7} style={noPadding}>
          <Select
            name="permissions"
            id="permissions"
            options={options}
            isMulti
            value={sharedUsersTeamsJS.length > 0 ? sharedUsersTeamsJS : []}
            onChange={handlePermissionsChoice}
            hideSelectedOptions
            filterOptions={customFilter}
            placeholder="Enter a user or team"
            classNamePrefix={
              usersTeamsValid === "error" ? "add-error-border " : ""
            }
          />
        </Col>
      </Row>
    </div>
  );
};

Permissions.propTypes = {
  users: PropTypes.object,
  inactiveUsers: PropTypes.object,
  teams: PropTypes.object,
  sharedUsersTeams: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onSetUserInput: PropTypes.func,
  fromAutomation: PropTypes.bool,
  fromResultsShare: PropTypes.bool,
  fromAdvanced: PropTypes.bool,
  jobCreatedBy: PropTypes.number,
  componentZIndex: PropTypes.number,
  usersTeamsValid: PropTypes.string,
};

export default Permissions;
